export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'
export const GET_USERS_STARTED = 'GET_USERS_STARTED'
export const UPDATE_USER_BY_ID = 'UPDATE_USER_BY_ID'
export const SET_USER = 'SET_USER'
